<template>
  <div>
    <b-row class="rda-tabs align-items-center" v-if="cycles.length > 0 && !loadingRDA">
      <b-col class="d-flex flex-wrap">
        <div
          v-for="(cycle, index) in cycles"
          :key="index"
          :class="`tab ${cycle.active ? 'active' : ''}`"
          @click="selectRdaTab(cycle)"
          style="margin-right: 10px; cursor: pointer"
        >
          <b>{{ cycle.designation }}</b>
          <span>
            {{ cycle.name }}{{ cycle.current ? " / Em curso" : "" }}
          </span>
        </div>
      </b-col>

      <b-col cols="auto" class="ms-auto" v-if="backButton && viewRda">
        <b-button class="btn medium blue" @click="backTableRda(true)">
          Voltar
        </b-button>
      </b-col>
    </b-row>

    <b-row
      v-if="!loadingRDA && !viewRda && rdaTab && subjects != null"
      class="rda-legend-container mb-4"
    >
      <b-col class="col-7">
        <rda-legend-component :allItems="false" />
      </b-col>

      <b-col class="rda-legend-col col-5">
        <div class="rda-legend">
          <span class="rda-legend-estimated">
            <strong>
              Estimativa para conclusão do ciclo em {{ getYearsText() }}:
            </strong>
          </span>
        </div>
        <div class="rda-legend">
          <div class="legend-item" v-if="percentages.faixa1">
            <div class="legend-color faixa1"></div>
            <span>1º Ano: {{ percentages.faixa1 }}</span>
          </div>
          <div class="legend-item" v-if="percentages.faixa2">
            <div class="legend-color faixa2"></div>
            <span>2º Ano: {{ percentages.faixa2 }}</span>
          </div>
          <div class="legend-item" v-if="percentages.faixa3">
            <div class="legend-color faixa3"></div>
            <span>3º Ano: {{ percentages.faixa3 }}</span>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row align="center" v-if="loadingRDA">
      <b-col class="mt-5">
        <b-spinner variant="success" label="Carregando..."></b-spinner>
      </b-col>
    </b-row>

    <div v-if="!loadingRDA && !viewRda">
      <div v-if="rdaTab && subjects != null">
        <b-row class="rda-tab-content">
          <b-col cols="7">
            <h4 class="mb-4">Áreas do Conhecimento</h4>
          </b-col>
          <b-col cols="5">
            <h4 class="mb-4">Evolução do aluno (Conteúdos Aprendidos)</h4>
          </b-col>
        </b-row>
        <b-row
          class="rda-tab-content"
          v-for="(item, index) in subjects.Subjects"
          :key="`row-${index}`"
        >
          <b-col cols="7">
            <b-row align-v="center" class="list-teacher">
              <b-col cols="5">
                <p>{{ item.designation }}</p>
              </b-col>
              <b-col>
                <span
                  class="tags"
                  style="padding: 5px; background-color: #a9a9a9"
                >
                  {{ item.totalTopics }} Conteúdos
                </span>
                <div class="tagsContainer" style="padding-top: 5px">
                  <span class="tags" style="background-color: #b23066">
                    EE:
                    {{
                      topicCounts[subjects.designation] &&
                      topicCounts[subjects.designation][item.id]
                        ? topicCounts[subjects.designation][item.id].EE
                        : 0
                    }}
                  </span>
                  <span class="tags">
                    A:
                    {{
                      topicCounts[subjects.designation] &&
                      topicCounts[subjects.designation][item.id]
                        ? topicCounts[subjects.designation][item.id].A
                        : 0
                    }}
                  </span>
                  <span class="tags" style="background-color: #ffbb00">
                    AN:
                    {{
                      topicCounts[subjects.designation] &&
                      topicCounts[subjects.designation][item.id]
                        ? topicCounts[subjects.designation][item.id].AN
                        : 0
                    }}
                  </span>
                </div>
              </b-col>
              <b-col
                cols="2"
                class="eye-legend"
                @click="
                  openViewRDA(item.id, item.cycle_id, subjects.designation)
                "
              >
                <span>Ver currículo</span>
                <button class="viewButton">
                  <ViewIcon />
                </button>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="5">
            <div class="progress-rda">
              <p>
                {{
                  isNaN(Number(item.percentage))
                    ? "0%"
                    : Number(item.percentage).toFixed(0) + "%"
                }}
              </p>
              <b
                :style="{
                  width: item.percentage + '%',
                  backgroundColor: '#d9d9d9',
                }"
                class="bar"
              ></b>

              <div
                v-if="percentages.faixa1"
                class="faixa faixa1"
                :style="{
                  left: getFaixaPosition(percentages.faixa1).min * 100 + '%',
                  width:
                    (getFaixaPosition(percentages.faixa1).max -
                      getFaixaPosition(percentages.faixa1).min) *
                      100 +
                    '%',
                }"
              ></div>

              <div
                v-if="percentages.faixa2"
                class="faixa faixa2"
                :style="{
                  left: getFaixaPosition(percentages.faixa2).min * 100 + '%',
                  width:
                    (getFaixaPosition(percentages.faixa2).max -
                      getFaixaPosition(percentages.faixa2).min) *
                      100 +
                    '%',
                }"
              ></div>

              <div
                v-if="percentages.faixa3"
                class="faixa faixa3"
                :style="{
                  left: getFaixaPosition(percentages.faixa3).min * 100 + '%',
                  width:
                    (getFaixaPosition(percentages.faixa3).max -
                      getFaixaPosition(percentages.faixa3).min) *
                      100 +
                    '%',
                }"
              ></div>

              <span
                class="lines"
                v-for="(line, index) in 0"
                :key="`line-${index}`"
              ></span>
            </div>
          </b-col>
        </b-row>
      </div>
      <div v-else>
        <b-row class="box-not-found">
          <ul class="message-not-found">
            <li>
              <p>Ainda não existem informações de ciclos para esse aluno.</p>
            </li>
          </ul>
        </b-row>
      </div>
    </div>

    <div class="viewRDA" v-if="!loadingRDA && viewRda">
      <b-row style="padding-bottom: 15px">
        <b-col cols="8">
          <rda-legend-component />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <div class="title-viewRDA title-view-rda" style="font-size: 22px">
            <b>{{ subjectSelected.designation }}</b>
          </div>
        </b-col>
      </b-row>
      <RDAComponentCompetence
        :subjectSelected="subjectSelected"
        :isParentView="isParentView"
      />
    </div>
  </div>
</template>

<script>
import RDAComponentCompetence from "@/components/RDAComponentCompetence.vue";
import RdaLegendComponent from "@/components/RdaLegendComponent.vue";
import ViewIcon from "@/components/svg/ViewIcon.vue";
import httpRda from "@/http-rda";
import moment from "moment-timezone";

export default {
  name: "StudentRDAComponent",
  components: {
    ViewIcon,
    RdaLegendComponent,
    RDAComponentCompetence,
  },
  props: {
    studentId: {
      type: [String, Number],
      required: true,
    },
    student: {
      type: Object,
      default: null,
    },
    currentYear: {
      type: Number,
      default: 1,
    },
    showRdaTable: {
      type: Boolean,
      default: true,
    },
    backButton: {
      type: Boolean,
      default: false,
    },
    selectedSubject: {
      type: Object,
      default: null,
    },
    isParentView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pendencyText: null,
      cycles: [],
      loadingRDA: false,
      rdaTab: true,
      viewRda: false,
      subjects: null,
      subjectSelected: null,
      allCyclesData: [],
      topicCounts: [],
      percentages: {},
      currentCycle: null,
      cycleVersions: {},
    };
  },
  methods: {
    getYearsText() {
      const faixasCount = [
        this.percentages.faixa1,
        this.percentages.faixa2,
        this.percentages.faixa3,
      ].filter(Boolean).length;

      return faixasCount === 1 ? "1 ano" : `${faixasCount} anos`;
    },
    setStatusColor(status) {
      switch (status) {
        case "EE":
          return "#b23066";
        case "AN":
          return "#ffbb00";
        case "*":
          return "#a9a9a9";
        case "#":
          return "#a9a9a9";
        default:
          return "#68c5b7";
      }
    },
    getFaixaPosition(faixa) {
      if (faixa.includes("-")) {
        const [min, maxWithSymbol] = faixa.split("-");
        const max = maxWithSymbol.replace("%", "");
        return { min: parseInt(min) / 100, max: parseInt(max) / 100 };
      } else {
        const value = parseInt(faixa.replace("%", ""));
        return { min: (value - 5) / 100, max: value / 100 };
      }
    },
    onModalClose() {
      this.pendencyText = null;
    },
    removeSpecialChars(text) {
      text = text.toLowerCase();
      text = text.replace(new RegExp("[ÁÀÂÃ]", "gi"), "a");
      text = text.replace(new RegExp("[ÉÈÊ]", "gi"), "e");
      text = text.replace(new RegExp("[ÍÌÎ]", "gi"), "i");
      text = text.replace(new RegExp("[ÓÒÔÕ]", "gi"), "o");
      text = text.replace(new RegExp("[ÚÙÛ]", "gi"), "u");
      text = text.replace(new RegExp("[Ç]", "gi"), "c");
      return text;
    },

    createSubjectCssClass(designation) {
      let aux = designation.toLowerCase();
      aux = aux.replace(/\s/g, "-");
      return this.removeSpecialChars(aux);
    },

    selectRdaTab(cycleSelected) {
      this.$emit("update:showRdaTable", true);
      this.$emit("update:selectedSubject", null);
      this.cycles.map((cycle) =>
        cycle.id === cycleSelected.id &&
        cycle.designation === cycleSelected.designation
          ? (cycle.active = true)
          : (cycle.active = false)
      );

      this.loadingRDA = true;
      this.rdaTab = true;
      const cycle = this.cycles.find(
        (c) =>
          c.id === cycleSelected.id &&
          c.designation === cycleSelected.designation
      );

      if (cycle) {
        const cycleVersion = this.cycleVersions[cycle.designation];
        let percentagesArray = cycle.percentages;
        const cyclePercentage = percentagesArray.find(
          (perc) => perc.version === cycleVersion
        );

        if (cyclePercentage) {
          this.percentages = cyclePercentage.percentages;
        } else {
          this.percentages = percentagesArray[0].percentages || {};
        }

        this.percentages = JSON.parse(this.percentages);
      }

      setTimeout(() => {
        this.defineCurrentSubjects();
        this.loadingRDA = false;
        this.viewRda = false;
      }, 100);
    },

    getCycleIndex() {
      return this.cycles.findIndex((cycle) => cycle.active == true);
    },

    defineCurrentSubjects() {
      this.subjects = this.allCyclesData.find(
        (cycle) =>
          cycle.id === this.cycles[this.getCycleIndex()].id &&
          cycle.designation === this.cycles[this.getCycleIndex()].designation
      );
    },

    openViewRDA(subjectId, cycleId, cycleDesignation) {
      this.loadingRDA = true;
      const subject = this.allCyclesData.find(
        (cycle) =>
          cycle.id === cycleId && cycle.designation === cycleDesignation
      );

      if (subject) {
        this.subjectSelected = subject.Subjects.find(
          (subj) => subj.id === subjectId
        );
        this.viewRda = true;
        this.loadingRDA = false;
        this.$emit("update:showRdaTable", false);
        this.$emit("update:selectedSubject", this.subjectSelected);
      } else {
        this.loadingRDA = false;
        this.$emit("update:selectedSubject", null);
        this.$bvToast.toast("Matéria não encontrada.", {
          title: "Erro",
          variant: "danger",
          solid: true,
        });
      }
    },

    formatDate(dateString) {
      if (!dateString) {
        return "";
      }
      return moment(dateString).format("DD/MM/YYYY");
    },

    backTableRda(status) {
      this.loadingRDA = true;
      this.rdaTab = status;

      this.$emit("update:showRdaTable", true);
      this.$emit("update:selectedSubject", null);

      this.$nextTick(() => {
        this.loadingRDA = false;
        this.viewRda = false;
      });
    },

    showEvidence(pendency) {
      this.pendencyText = pendency;
      this.$bvModal.show("modal-evidence");
    },

    async getStudentCycles() {
      this.loadingRDA = true;
      await httpRda
        .get(`/tutoring/student/${this.studentId}/cycles`)
        .then((response) => {
          this.cycles = response.data.cycles;
          this.cycles = this.cycles.map((cycle) => {
            if (cycle.current === true) {
              this.currentCycle = cycle;
            }
            return {
              ...cycle,
              active: cycle.current === true ? true : false,
            };
          });
        });
      this.loadingRDA = false;
    },

    async getStudentSubjects() {
      try {
        this.topicCounts = {};
        this.loadingRDA = true;
        let subjectsAll = await httpRda.get(
          `/tutoring/student/${this.studentId}/allCyclesData`
        );
        subjectsAll = subjectsAll.data.result;

        if (
          subjectsAll.message &&
          this.currentCycle &&
          this.currentCycle.id !== 6 &&
          this.currentCycle.id !== 8
        ) {
          this.$bvToast.toast(subjectsAll.message, {
            title: "Erro",
            variant: "danger",
            solid: true,
          });
          return;
        }

        if (!subjectsAll) {
          this.loadingRDA = false;
          return;
        }

        subjectsAll.map((data) => {
          this.cycleVersions[data.designation] = data.version;

          if (!this.topicCounts[data.designation]) {
            this.topicCounts[data.designation] = {};
          }

          data.Subjects.map((subject) => {
            subject.Competences.map((competence) => {
              competence.Topics.map((topic) => {
                topic.TopicStudents.map((item) => {
                  if (item.status === "EE") {
                    subject.status = item.status;
                  }

                  if (!this.topicCounts[data.designation][subject.id]) {
                    this.topicCounts[data.designation][subject.id] = {
                      EE: 0,
                      A: 0,
                      AN: 0,
                    };
                  }
                  if (item.status !== "#") {
                    this.topicCounts[data.designation][subject.id][
                      item.status
                    ] =
                      (this.topicCounts[data.designation][subject.id][
                        item.status
                      ] || 0) + 1;
                  }
                });
              });
            });
          });
        });

        this.allCyclesData = subjectsAll;

        this.defineCurrentSubjects();
        this.loadingRDA = false;
      } catch (error) {
        this.loadingRDA = false;
      }
    },

    async loadData() {
      await this.getStudentCycles();
      await this.getStudentSubjects();
    },
  },
  async created() {
    await this.loadData();
    if (this.cycles.length > 0) {
      const activeCycle = this.cycles.find((cycle) => cycle.current === true);
      if (activeCycle) {
        const cycleVersion = this.cycleVersions[activeCycle.designation];
        let percentagesArray = activeCycle.percentages;
        const cyclePercentage = percentagesArray.find(
          (perc) => perc.version === cycleVersion
        );

        if (cyclePercentage) {
          this.percentages = cyclePercentage.percentages;
        } else {
          this.percentages = percentagesArray[0].percentages || {};
        }

        this.percentages = JSON.parse(this.percentages);
      }
    }
  },
  watch: {
    studentId: {
      handler: async function () {
        await this.loadData();
      },
    },
    showRdaTable: {
      handler(newValue) {
        if (newValue === true) {
          this.viewRda = false;
        } else {
          if (this.subjectSelected) {
            this.viewRda = true;
          }
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
$artes-visuais: #b2ecf7;
$lingua-estrangeira: #ffc2c2;
$ciencias-da-natureza: #d1e7c0;
$ciencias-humanas: #d8c7ee;
$corpo-e-mente: #ffd97d;
$danca: #ff8b94;
$historia: #ffd9b6;
$lingua-portuguesa: #b2c9f7;
$matematica: #ffc9ed;
$espanhol: #a3e0ce;
$musica: #ffad76;
$cidadania-vida: #e7b3c8;
$teatro: #aedbad;
$ingles: #90a8e6;

.progress-rda {
  /* estilos existentes */
  position: relative;

  .faixa {
    position: absolute;
    height: 100%;
    top: 0;
    z-index: 1;
    opacity: 0.4;
    pointer-events: none;
  }

  .faixa1 {
    background: repeating-linear-gradient(
      45deg,
      #b23066,
      #b23066 10px,
      rgba(178, 48, 102, 0.6) 10px,
      rgba(178, 48, 102, 0.6) 20px
    );
  }

  .faixa2 {
    background: repeating-linear-gradient(
      45deg,
      #36b67d,
      #36b67d 10px,
      rgba(54, 182, 125, 0.6) 10px,
      rgba(54, 182, 125, 0.6) 20px
    );
  }

  .faixa3 {
    background: repeating-linear-gradient(
      45deg,
      #ffbb00,
      #ffbb00 10px,
      rgba(255, 187, 0, 0.6) 10px,
      rgba(255, 187, 0, 0.6) 20px
    );
  }

  /* restante dos estilos */
}

.eye-legend {
  flex-direction: column;
  display: flex;
  align-items: center;

  span {
    font-size: 14px;
  }
}

.evidence-btn {
  border-radius: 5px;
  background-color: #68c5b7;
  color: white;
  border: none;
}

.box-not-found {
  display: flex;
  flex-direction: row;
  justify-content: center;
  widows: 100%;
}

.message-not-found {
  width: 50%;
  background: white;
  border: 1px solid #ededed;
  border-radius: 6px;
  padding: 10px;
  text-align: center;
  box-sizing: border-box;
  list-style: none;

  p {
    margin: 0;
  }
}

.rda-tabs {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  margin-bottom: 40px;

  .tab {
    background: linear-gradient(180deg, #fff -16%, #fff 113%);
    flex: 0 0 270px;
    height: 94px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 8;
    transition: 0.2s all;
    cursor: pointer;

    &:hover {
      box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
    }

    &.active {
      background: linear-gradient(180deg, #ef6549 -16%, #b23066 113%);

      b,
      span {
        color: #fff;
      }
    }

    b {
      font-size: 16px;
      color: #666666;
    }

    span {
      font-size: 14px;
      color: #666666;
    }
  }
}

.rda-tab-content {
  padding-left: 0;

  &:last-child {
    .progress-rda {
      .lines {
        height: 100%;
        top: 0;
      }
    }
  }
}

.progress-rda {
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  position: relative;
  overflow: visible !important;

  &:after {
    content: "";
    background: #f2f2f2;
    width: 100%;
    height: 80px;
    border-radius: 0 10px 10px 0;
    position: absolute;
    top: 0;
    left: 0px;
    z-index: 0;
  }

  p {
    font-size: 18px;
    margin: 0;
    position: absolute;
    top: 50%;
    left: 16px;
    transform: translateY(-50%);
    z-index: 2;
  }

  .bar {
    background: #d8c7ee;
    height: 100%;
    border-radius: 0 10px 10px 0;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;

    &.artes-visuais {
      background: $artes-visuais;
    }

    &.lingua-estrangeira {
      background: $lingua-estrangeira;
    }

    &.ciencias-da-natureza {
      background: $ciencias-da-natureza;
    }

    &.ciencias-humanas {
      background: $ciencias-humanas;
    }

    &.corpo-e-mente {
      background: $corpo-e-mente;
    }

    &.danca {
      background: $danca;
    }

    &.historia {
      background: $historia;
    }

    &.lingua-portuguesa {
      background: $lingua-portuguesa;
    }

    &.matematica {
      background: $matematica;
    }

    &.espanhol {
      background: $espanhol;
    }

    &.musica {
      background: $musica;
    }

    &.cidadania-vida {
      background: $cidadania-vida;
    }

    &.teatro {
      background: $teatro;
    }

    &.ingles {
      background: $ingles;
    }
  }

  .lines {
    width: 1px;
    height: 116%;
    display: block;
    border-left: 1px dashed #b3b3b3;
    position: relative;
    top: 6px;
    z-index: 2;
  }
}

.viewButton {
  background: transparent;
  border: 0;

  svg {
    width: 20px;
  }
}

.tagsContainer {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
}

.tags {
  &.warning {
    background-color: var(--orange);
  }
}

.back-rda {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  margin-bottom: 40px;
  cursor: pointer;

  svg {
    transform: rotate(180deg);
    height: 18px;
  }

  span {
    font-size: 18px;
    font-weight: bold;
    color: #4f4f4f;
    position: relative;
    top: 2px;
  }
}

.title-viewRDA {
  background: linear-gradient(270deg, #6883c5 0%, #36b67d 100%);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  margin-bottom: 40px;

  b {
    color: #fff;
    font-weight: bold;
  }

  span {
    color: #fff;
  }
}

.rda-viewlist {
  margin-bottom: 30px;
  padding-left: 30px;

  .title {
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    color: #36b67d;
    margin-bottom: 12px;
  }

  .item-rda-viewlist {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;

    .cols {
      .tags {
        min-width: 40px;
      }
    }

    .text-col {
      flex: 1;
    }
  }

  .competence-details {
    color: #b23066;
    font-weight: 700;
  }

  .tematic-unit-title {
    color: #36b67d;
    font-weight: 600;
    font-size: 18px;
  }

  .comp-description {
    padding-right: 40px !important;
    font-size: 16px !important;
    line-height: 20px;
  }

  .knowledge-object-title {
    font-weight: 600;
    font-size: 16px;
  }

  .topic-description {
    font-size: 14px;
    line-height: 18px;
  }
}

.rda-legend {
  display: flex;
  justify-content: flex-start;
}

.rda-legend-estimated {
  line-height: 20px;
  padding-top: 2px;
}

.legend-item {
  display: flex;
  align-items: center;
  margin: 0 10px;
  margin-left: 0px !important;
}

.legend-color {
  width: 15px;
  height: 15px;
  margin-right: 5px;
}

.rda-legend-col {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.rda-legend-status {
  padding-top: 20 px;
  align-items: flex-start;

  p {
    font-size: 16px;
    line-height: 1.2;
  }
}

.legend-color.faixa1 {
  background: repeating-linear-gradient(
    45deg,
    #b23066,
    #b23066 5px,
    rgba(178, 48, 102, 0.6) 5px,
    rgba(178, 48, 102, 0.6) 10px
  );
}

.legend-color.faixa2 {
  background: repeating-linear-gradient(
    45deg,
    #36b67d,
    #36b67d 5px,
    rgba(54, 182, 125, 0.6) 5px,
    rgba(54, 182, 125, 0.6) 10px
  );
}

.legend-color.faixa3 {
  background: repeating-linear-gradient(
    45deg,
    #ffbb00,
    #ffbb00 5px,
    rgba(255, 187, 0, 0.6) 5px,
    rgba(255, 187, 0, 0.6) 10px
  );
}
</style>
